"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMatchtargetingrulesetV1 = exports.postMakeofferV2 = exports.getOfferV2 = exports.getNextBestOfferWithEstimatesV4 = exports.getNextBestOfferWithEstimatesV3 = exports.getMultisiteOfferWithEstimates = exports.getNextBestBannerV4 = exports.getNextBestBannerV3 = exports.getNextBestBannerV2 = exports.getModelContractV2 = exports.getProfileV5Bpm = exports.getProfileV5 = exports.getProfileV4 = exports.getProfileV3 = exports.getProfileV2 = exports.getProfileV1 = exports.getNextBestOfferV4 = exports.postAcquisitionScoreV1 = exports.getNextBestProposition = exports.postFeedback = void 0;
/**
 * Send feedback to either offerstore or action store.
 * This endpoint accepts either an offer id or an action id, your request will be routed to the offer store and action store accordingly
 * The feedback type can be either offerstore feedback or action feedback, depending on the actionId or offerId you will need to send in correct feedback
 * @param data The data for the request.
 * @param data.requestBody
 * @returns OfferStore_AcceptedResponse OK
 * @throws ApiError
 */
const postFeedback = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/marketing/feedback/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postFeedback = postFeedback;
/**
 * Returns the next best propositions for the provided profile and parameters using the same matching logic as nextbestoffer, but won't create an offer.
 * Returns the next best proposition for the given profile and filter parameters.
 * See the confluence page for how the matching works.
 * Every request to this endpoint is read-only, it won't save any offers or feedback when called, unlike nextbestoffer
 * @param data The data for the request.
 * @param data.maxPropositions The max number of propositions that should be returned.
 * Due to our offer feedback rule engine, we can not promise a minimum number of propositions to be returned.
 * @param data.profileId Profile ID as retrieved from the Identification Service
 * @param data.electricityProductId The current electricity product ID from SAP, used in the matching logic. If no product is provided UPS data is used to get most recent product.
 * @param data.gasProductId The current gas product ID from SAP, used in the matching logic. If no product is provided UPS data is used to get most recent product.
 * @param data.channel Should be left empty since channel is now read from the api key.
 * @param data.durations Specify for which durations you want to filter the propositions for.
 * @param data.segmentTypes Filter for which segment you want to offers for.
 * Not all offers are created for all segments.
 * For example 'SME acq VAR Plus DF (nov)' is only for SME customers.
 * @param data.productTypes Filter for which transition rules as defined by the campaign management the campaign (and thus the proposition) should match
 * @returns GetPropositionsListResponse OK
 * @throws ApiError
 */
const getNextBestProposition = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/nextbestproposition/v1',
        query: {
            max_propositions: data.maxPropositions,
            profile_id: data.profileId,
            electricity_product_id: data.electricityProductId,
            gas_product_id: data.gasProductId,
            channel: data.channel,
            durations: data.durations,
            segment_types: data.segmentTypes,
            product_types: data.productTypes
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getNextBestProposition = getNextBestProposition;
/**
 * Querying aquisition score by address key
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GetAcquisitionScoreResponse OK
 * @throws ApiError
 */
const postAcquisitionScoreV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/marketing/acquisition-score/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postAcquisitionScoreV1 = postAcquisitionScoreV1;
/**
 * Retrieve next best offer from the Offer Store
 * @param data The data for the request.
 * @param data.maxOffers The max number of offers that should be returned.
 * Due to our offer feedback rule engine, we can not promise a minimum number of offers to be returned.
 * @param data.profileId Profile ID as retrieved from the Identification Service
 * @param data.customerId Customer ID to retrieve the next best offers for
 * @param data.deliveryAddress Not used in retrieving the offer, but for the offer feedback.
 * Specify this field if you know the address, that will help with collecting feedback data.
 * @param data.channel Should be left empty since channel is now read from the api key.
 * @param data.durations Specify for which durations you want to filter the propositions for.
 * @param data.segmentType Filter for which segment you want to offers for.
 * Not all offers are created for all segments.
 * For example 'SME acq VAR Plus DF (nov)' is only for SME customers.
 * @param data.productTypes Filter for which transition rules as defined by the campaign management the campaign (and thus the proposition) should match
 * @returns GetNextBestOfferResponseV3 OK
 * @throws ApiError
 */
const getNextBestOfferV4 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/offer/v4',
        query: {
            max_offers: data.maxOffers,
            profile_id: data.profileId,
            customer_id: data.customerId,
            delivery_address: data.deliveryAddress,
            channel: data.channel,
            durations: data.durations,
            segmentType: data.segmentType,
            product_types: data.productTypes
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            501: 'feature_not_implemented',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getNextBestOfferV4 = getNextBestOfferV4;
/**
 * @deprecated
 * Get profileId, churn score and priorities
 * @param data The data for the request.
 * @param data.xApiKey The api key for this request, may be derived from clientId. When calling an API using a frontend this can be set as an empty string, it should get replaced by the public API proxy
 * @param data.customerId ID of the customer. Either this or the delivery_address_key must be provided.
 * @param data.deliveryAddressKey Delivery address of the customer. Either this or the customer_id must be provided.
 * @returns GetProfileResponse OK
 * @throws ApiError
 */
const getProfileV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/profile/v1',
        headers: {
            'x-api-key': data.xApiKey
        },
        query: {
            customer_id: data.customerId,
            delivery_address_key: data.deliveryAddressKey
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProfileV1 = getProfileV1;
/**
 * @deprecated
 * Get profileId, churn score and priorities
 * @param data The data for the request.
 * @param data.xApiKey The api key for this request, may be derived from clientId. When calling an API using a frontend this can be set as an empty string, it should get replaced by the public API proxy
 * @param data.customerId ID of the customer. Either this or the delivery_address_key must be provided.
 * @param data.deliveryAddressKey Delivery address of the customer. Either this or the customer_id must be provided.
 * @returns GetProfileResponseV2 OK
 * @throws ApiError
 */
const getProfileV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/profile/v2',
        headers: {
            'x-api-key': data.xApiKey
        },
        query: {
            customer_id: data.customerId,
            delivery_address_key: data.deliveryAddressKey
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProfileV2 = getProfileV2;
/**
 * @deprecated
 * Get profileId, churn score and priorities
 * @param data The data for the request.
 * @param data.customerId ID of the customer. This parameter can be omitted for non-customers only! If it's used when searching for an actual customer it will not return a profile.
 * @param data.deliveryAddressKey Delivery address of the customer.
 * @param data.xApiKey The api key for this request, may be derived from clientId. When calling an API using a frontend this can be set as an empty string, it should get replaced by the public API proxy
 * @returns GetProfileResponseV2 OK
 * @throws ApiError
 */
const getProfileV3 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/profile/v3',
        headers: {
            'x-api-key': data.xApiKey
        },
        query: {
            customer_id: data.customerId,
            delivery_address_key: data.deliveryAddressKey
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProfileV3 = getProfileV3;
/**
 * Get profileId, churn score and priorities
 * @param data The data for the request.
 * @param data.deliveryAddressKey Delivery address of the customer.
 * @param data.xApiKey The api key for this request, may be derived from clientId. When calling an API using a frontend this can be set as an empty string, it should get replaced by the public API proxy
 * @param data.customerId ID of the customer. This parameter can be omitted for non-customers only! If it's used when searching for an actual customer it will not return a profile.
 * @returns GetProfileResponseV2 OK
 * @throws ApiError
 */
const getProfileV4 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/profile/v4',
        headers: {
            'x-api-key': data.xApiKey
        },
        query: {
            customer_id: data.customerId,
            delivery_address_key: data.deliveryAddressKey
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProfileV4 = getProfileV4;
/**
 * Get profileId, churn score and priorities
 * Returns a matching profile based off the provided query filters. Will include ex-customers unless excluded in the request query.
 * @param data The data for the request.
 * @param data.deliveryAddressKey Delivery address of the customer.
 * @param data.xApiKey The api key for this request, may be derived from clientId. When calling an API using a frontend this can be set as an empty string, it should get replaced by the public API proxy
 * @param data.customerId ID of the customer. This parameter can be omitted for non-customers only! If it's used when searching for an actual customer it will not return a profile.
 * @param data.customerPhasesFilter Filter for the Customer (Journey) Phase. If not provided all phases will be included, including ex-customers and customers without a phase.
 * @returns GetProfileResponseV2 OK
 * @throws ApiError
 */
const getProfileV5 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/profile/v5',
        headers: {
            'x-api-key': data.xApiKey
        },
        query: {
            customer_id: data.customerId,
            delivery_address_key: data.deliveryAddressKey,
            customer_phases_filter: data.customerPhasesFilter
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProfileV5 = getProfileV5;
/**
 * Get profileId, churn score and priorities via BPM
 * Returns a matching profile based off the provided query filters. Will include ex-customers unless excluded in the request query.
 * @param data The data for the request.
 * @param data.deliveryAddressKey Delivery address of the customer.
 * @param data.xApiKey The api key for this request, may be derived from clientId. When calling an API using a frontend this can be set as an empty string, it should get replaced by the public API proxy
 * @param data.customerId ID of the customer. This parameter can be omitted for non-customers only! If it's used when searching for an actual customer it will not return a profile.
 * @param data.customerPhasesFilter Filter for the Customer (Journey) Phase. If not provided all phases will be included, including ex-customers and customers without a phase.
 * @returns GetProfileResponseV2 OK
 * @throws ApiError
 */
const getProfileV5Bpm = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/bpm/profile/v5',
        headers: {
            'x-api-key': data.xApiKey
        },
        query: {
            customer_id: data.customerId,
            delivery_address_key: data.deliveryAddressKey,
            customer_phases_filter: data.customerPhasesFilter
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getProfileV5Bpm = getProfileV5Bpm;
/**
 * Based on the given address it will return the model contract as required by law.
 * @param data The data for the request.
 * @param data.addressKey The address for which you want the tariffs.
 * Based on the address the call is made to EDSN to fetch the grid operator and net area.
 * The net area is used only for gas tariffs. And the grid operator is used to fetch the default captar code.
 * These combined give the netbeheerder kosten.
 * @param data.segment Describes for which function the building for the given address is being used.
 * AOM smashes household and Small Office/Home Office (SOHO) together and all other segments as small medium enterprise.
 * Since different laws apply for households and non-households. This influences all the cost: netbeheerder, levering and belasting.
 * @param data.campaignId This should be the model contract campaign.
 * This influence the levering kosten. For any question regarding the campaign, contact the Campaign Management team.
 * @param data.returnSupply If true then in the response you will see the cost rate of return electricity back to the grid.
 * When calling AOM we only fill in the consumptionReturnPeak. The consumption return off peak, so the off hours, have no influence on the rate
 * as far as we can see. Atleast not for the model contract.
 * @param data.rate Specifies if the users wants to see the rates when only using a single tariff throughout the day.
 * Or when the user wants to see the night and day tariff. We default the verbruiksprofiel to E1A for single rate and E2A for double rate.
 * @param data.duration The duration of the contact. Defaults to flex also known as 99.
 * This influences the proposition that is picked. The duration should exist for the given campaign. Otherwise you will get a 400.
 * Contact the Campaign Management team or I Pay AOM to know which durations are avaible for the campaign.
 * There is no API to get this information.
 * @param data.residential If the building on the given address is being used as a living place (woonfunctie).
 * This must be provided by the user. We are not allowed to guess or fetch this from BAG by law!
 * @returns GetProductTariffsResponseV3 OK
 * @throws ApiError
 */
const getModelContractV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/model-contract/v2',
        query: {
            address_key: data.addressKey,
            segment: data.segment,
            campaign_id: data.campaignId,
            duration: data.duration,
            residential: data.residential,
            return_supply: data.returnSupply,
            rate: data.rate
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getModelContractV2 = getModelContractV2;
/**
 * @deprecated
 * Retrieve next best banner from the Offer Store and Information store, combining both results in the banners field.
 * @param data The data for the request.
 * @param data.maxBanners The max number of offers that should be returned.
 * Due to our offer feedback rule engine, we can not promise a minimum number of offers to be returned.
 * @param data.profileId Profile ID as retrieved from the Identification Service
 * @param data.content Content helps to retrieve data from Sitecore
 * @param data.segmentType Specifies the segment type used to retrieve data from the respective SBS in Sitecore.
 * @param data.channel Should be left empty since channel is now read from the api key.
 * @param data.durations Specify for which durations you want to filter the propositions for.
 * @param data.segmentTypes Filter for which segment you want to offers for.
 * Not all offers are created for all segments.
 * For example 'SME acq VAR Plus DF (nov)' is only for SME customers.
 * @param data.productTypes Filter for which transition rules as defined by the campaign management the campaign (and thus the proposition) should match
 * @param data.deliveryAddress Not used in retrieving the offer, but for the offer feedback.
 * Specify this field if you know the address, that will help with collecting feedback data.
 * @returns GetNextBestBannerResponseV2 OK
 * @throws ApiError
 */
const getNextBestBannerV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/next-best-banner/v2',
        query: {
            max_banners: data.maxBanners,
            profile_id: data.profileId,
            content: data.content,
            segmentType: data.segmentType,
            channel: data.channel,
            durations: data.durations,
            segment_types: data.segmentTypes,
            product_types: data.productTypes,
            delivery_address: data.deliveryAddress
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getNextBestBannerV2 = getNextBestBannerV2;
/**
 * Retrieve next best banner from the Offer Store and Information store, combining both results in the banners field.
 * @param data The data for the request.
 * @param data.maxBanners The max number of banners that should be returned.
 * Due to our offer feedback rule engine, we can not promise a minimum number of banners to be returned.
 * @param data.profileId Profile ID as retrieved from the Identification Service
 * @param data.deliveryAddress Not used in retrieving the offer, but for the offer feedback.
 * Specify this field if you know the address, that will help with collecting feedback data.
 * @param data.channel Should be left empty since channel is now read from the api key.
 * @param data.durations Specify for which durations you want to filter the propositions for.
 * @param data.segmentType Filter for which segment you want to offers for.
 * Not all offers are created for all segments.
 * For example 'SME acq VAR Plus DF (nov)' is only for SME customers.
 * @param data.productTypes Filter for which transition rules as defined by the campaign management the campaign (and thus the proposition) should match
 * @param data.content Content helps to retrieve data from Sitecore
 * @returns GetNextBestBannerResponseV3 OK
 * @throws ApiError
 */
const getNextBestBannerV3 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/next-best-banner/v3',
        query: {
            max_banners: data.maxBanners,
            profile_id: data.profileId,
            delivery_address: data.deliveryAddress,
            channel: data.channel,
            durations: data.durations,
            segmentType: data.segmentType,
            product_types: data.productTypes,
            content: data.content
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getNextBestBannerV3 = getNextBestBannerV3;
/**
 * Retrieve next best banner from the Offer Store and Information store, combining both results in the banners field.
 * @param data The data for the request.
 * @param data.maxBanners The max number of banners that should be returned.
 * Due to our offer feedback rule engine, we can not promise a minimum number of banners to be returned.
 * @param data.profileId Profile ID as retrieved from the Identification Service
 * @param data.deliveryAddress Not used in retrieving the offer, but for the offer feedback.
 * Specify this field if you know the address, that will help with collecting feedback data.
 * @param data.channel Should be left empty since channel is now read from the api key.
 * @param data.durations Specify for which durations you want to filter the propositions for.
 * @param data.segmentType Filter for which segment you want to offers for.
 * Not all offers are created for all segments.
 * For example 'SME acq VAR Plus DF (nov)' is only for SME customers.
 * @param data.productTypes Filter for which transition rules as defined by the campaign management the campaign (and thus the proposition) should match
 * @param data.content Content helps to retrieve data from Sitecore
 * @returns GetNextBestBannerResponseV4 OK
 * @throws ApiError
 */
const getNextBestBannerV4 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/next-best-banner/v4',
        query: {
            max_banners: data.maxBanners,
            profile_id: data.profileId,
            delivery_address: data.deliveryAddress,
            channel: data.channel,
            durations: data.durations,
            segmentType: data.segmentType,
            product_types: data.productTypes,
            content: data.content
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getNextBestBannerV4 = getNextBestBannerV4;
/**
 * Based on the given addresses it will return the next best offers with tariffs and yearly amount for each address
 * @param data The data for the request.
 * @param data.requestBody
 * @returns GetMultisiteOfferWithEstimatesResponse OK
 * @throws ApiError
 */
const getMultisiteOfferWithEstimates = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/marketing/multisite-offer-with-estimates/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getMultisiteOfferWithEstimates = getMultisiteOfferWithEstimates;
/**
 * @deprecated
 * Based on the given address it will return the next best offers with tariffs and yearly amount for each address
 * @param data The data for the request.
 * @param data.segmentType The type of segment the address falls in.
 * @param data.deliveryAddress Address of the building for which the offer is intended.
 * It should match the same address you have used to get the profile id from the Identification Service
 * @param data.profileId Profile ID as retrieved from the Identification Service. Required when retrieving retention offers but can be omitted if retrieving acquisition offers.
 * @param data.funnelType Funnel type for the returned offers, can be either 'acquisition' or 'retention'
 * @param data.channel Should be left empty since channel is now read from the api key.
 * @param data.durations Filter for which contract duration you want the offers.
 * If it is left empty, it will fetch contract with all the possible durations.
 * @param data.maxOffers The max number of offers that should be returned. Defaults to maximum of three.
 * @param data.accountId The customer/account ID from SAP, used to find installation details
 * @param data.supplyAddressId The address ID from SAP, used to find installation details
 * @param data.contractGroupId The contract group ID from SAP, used to find installation details
 * @param data.electricityProductId The current electricity product ID from SAP, used in the matching logic
 * @param data.gasProductId The current gas product ID from SAP, used in the matching logic
 * @param data.complex Also known as complex bepaling.
 * This information is maintained by EDSN.
 * For tariffs, if residential is true and complex is false, that address will get belasting voordeel.
 * If you are fetching tariffs in the last phase of BAC or Change Contract you must provide this value by law!
 * Defaults to false.
 * @param data.residential If true it means that is a "regular" home.
 * It only influence if it receives belasting voordeel.
 * If you are fetching tariffs in the last phase of BAC or Change Contract you must provide this value by law!
 * If you are fetching tariffs in the last phase of BAC or Change Contract you must provide this value by law!
 * Defaults to true
 * @param data.electricityConsumptionPeak The expected yearly electricity consumption in kWh
 * @param data.electricityConsumptionOffPeak The expected yearly electricity consumption in kWh in the "off" hours
 * @param data.electricityConsumptionReturnPeak The expected amount of kWh that is returned on the net during the day
 * @param data.electricityConsumptionReturnOffPeak The expected amount of kWh that is returned on the net in the "off" hours
 * @param data.electricityInstallationProfile The profile of the electricity meter/installation.
 * heavily influences the supply rates. Describes the maximum usage of the building.
 * We try to find the profile if it is an existing customer, otherwise it will default to E1C.
 * @param data.electricityCaptarEan States what kind of installation you have.
 * For example if you have 3x25 ampere or only 1x80.
 * This heavily influences the tariffs you receive.
 * You find the result under "Netbeheerder kosten".
 * @param data.gasConsumption The expected yearly gas consumption in m3.
 * If not set, it will try to fetch the consumption of EDSN if it is an existing customer.
 * Otherwise it will default to 1_300
 * @param data.gasNetAreaEan The net area EAN, can be retrieved from EDSN also for non existing customers.
 * This determines in which "region" you live, numbered from 01 up to 10.
 * For each region there is a different supply rate.
 * For example with the same installation and segment, but different net area, could result in a difference of 0.01 euro in unit price.
 * @param data.gasInstallationProfile The profile of the gas meter/installation.
 * Describes the maximum usage of the building.
 * Heavily influences the supply rates.
 * We try to find the profile if it is an existing customer, otherwise it will default to G1A.
 * @param data.gasCaptarEan States per netbeheerder the maximum amount of gas in m3 per hour the building is allowed to use.
 * For example, if the gas installation has the captar 8742080201114 is then managed by NV Rendo and states the maximum input is 10m3/h with a maximum year usage of less than 500m3 gas.
 * This value can be retrieved at EDSN for everyone.
 * This heavily influences the tariffs you receive.
 * You find the result under "Netbeheerder kosten".
 * @returns Marketing_GetOfferWithEstimatesResponseV3 OK
 * @throws ApiError
 */
const getNextBestOfferWithEstimatesV3 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/offer-with-estimates/v3',
        query: {
            profile_id: data.profileId,
            funnel_type: data.funnelType,
            channel: data.channel,
            durations: data.durations,
            max_offers: data.maxOffers,
            account_id: data.accountId,
            supply_address_id: data.supplyAddressId,
            contract_group_id: data.contractGroupId,
            electricity_product_id: data.electricityProductId,
            gas_product_id: data.gasProductId,
            segment_type: data.segmentType,
            delivery_address: data.deliveryAddress,
            complex: data.complex,
            residential: data.residential,
            electricity_consumption_peak: data.electricityConsumptionPeak,
            electricity_consumption_off_peak: data.electricityConsumptionOffPeak,
            electricity_consumption_return_peak: data.electricityConsumptionReturnPeak,
            electricity_consumption_return_off_peak: data.electricityConsumptionReturnOffPeak,
            electricity_installation_profile: data.electricityInstallationProfile,
            electricity_captar_ean: data.electricityCaptarEan,
            gas_consumption: data.gasConsumption,
            gas_net_area_ean: data.gasNetAreaEan,
            gas_installation_profile: data.gasInstallationProfile,
            gas_captar_ean: data.gasCaptarEan
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getNextBestOfferWithEstimatesV3 = getNextBestOfferWithEstimatesV3;
/**
 * Based on the given address it will return the next best offers with tariffs and yearly amount for each given connection
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Marketing_GetOfferWithEstimatesResponseV3 OK
 * @throws ApiError
 */
const getNextBestOfferWithEstimatesV4 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/marketing/offer-with-estimates/v4',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getNextBestOfferWithEstimatesV4 = getNextBestOfferWithEstimatesV4;
/**
 * Based on the given offer id, return information about that offer.
 * Also retrieves the current tariffs and yearly amount for given offer on this moment.
 * The new tariffs for today are retrieved every time this endpoint is called, so they are possibly different from the tariffs returned when the offer was created.
 * @param data The data for the request.
 * @param data.offerId Offer UUID
 * @param data.segmentType The type of segment the address falls in.
 * @param data.complex Also known as complex bepaling.
 * This information is maintained by EDSN.
 * For tariffs, if residential is true and complex is false, that address will get belasting voordeel.
 * If you are fetching tariffs in the last phase of BAC or Change Contract you must provide this value by law!
 * Defaults to false.
 * @param data.residential If true it means that is a "regular" home.
 * It only influence if it receives belasting voordeel.
 * If you are fetching tariffs in the last phase of BAC or Change Contract you must provide this value by law!
 * If you are fetching tariffs in the last phase of BAC or Change Contract you must provide this value by law!
 * Defaults to true
 * @param data.electricityConsumptionPeak The expected yearly electricity consumption in kWh
 * @param data.electricityConsumptionOffPeak The expected yearly electricity consumption in kWh in the "off" hours
 * @param data.electricityConsumptionReturnPeak The expected amount of kWh that is returned on the net during the day
 * @param data.electricityConsumptionReturnOffPeak The expected amount of kWh that is returned on the net in the "off" hours
 * @param data.electricityInstallationProfile The profile of the electricity meter/installation.
 * heavily influences the supply rates. Describes the maximum usage of the building.
 * We try to find the profile if it is an existing customer, otherwise it will default to E1C.
 * @param data.electricityCaptarEan States what kind of installation you have.
 * For example if you have 3x25 ampere or only 1x80.
 * This heavily influences the tariffs you receive.
 * You find the result under "Netbeheerder kosten".
 * @param data.gasConsumption The expected yearly gas consumption in m3.
 * If not set, it will try to fetch the consumption of EDSN if it is an existing customer.
 * Otherwise it will default to 1_300
 * @param data.gasNetAreaEan The net area EAN, can be retrieved from EDSN also for non existing customers.
 * This determines in which "region" you live, numbered from 01 up to 10.
 * For each region there is a different supply rate.
 * For example with the same installation and segment, but different net area, could result in a difference of 0.01 euro in unit price.
 * @param data.gasInstallationProfile The profile of the gas meter/installation.
 * Describes the maximum usage of the building.
 * Heavily influences the supply rates.
 * We try to find the profile if it is an existing customer, otherwise it will default to G1A.
 * @param data.gasCaptarEan States per netbeheerder the maximum amount of gas in m3 per hour the building is allowed to use.
 * For example, if the gas installation has the captar 8742080201114 is then managed by NV Rendo and states the maximum input is 10m3/h with a maximum year usage of less than 500m3 gas.
 * This value can be retrieved at EDSN for everyone.
 * This heavily influences the tariffs you receive.
 * You find the result under "Netbeheerder kosten".
 * @param data.channel Should be left empty since channel is now read from the api key.
 * @returns GetOfferResponseV2 OK
 * @throws ApiError
 */
const getOfferV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/offer/v2/{offerId}',
        path: {
            offerId: data.offerId
        },
        query: {
            segment_type: data.segmentType,
            channel: data.channel,
            complex: data.complex,
            residential: data.residential,
            electricity_consumption_peak: data.electricityConsumptionPeak,
            electricity_consumption_off_peak: data.electricityConsumptionOffPeak,
            electricity_consumption_return_peak: data.electricityConsumptionReturnPeak,
            electricity_consumption_return_off_peak: data.electricityConsumptionReturnOffPeak,
            electricity_installation_profile: data.electricityInstallationProfile,
            electricity_captar_ean: data.electricityCaptarEan,
            gas_consumption: data.gasConsumption,
            gas_net_area_ean: data.gasNetAreaEan,
            gas_installation_profile: data.gasInstallationProfile,
            gas_captar_ean: data.gasCaptarEan
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            501: 'feature_not_implemented',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getOfferV2 = getOfferV2;
/**
 * Makes an offer based on proposition
 * @param data The data for the request.
 * @param data.requestBody
 * @returns MakeOfferFSResponseV2 OK
 * @throws ApiError
 */
const postMakeofferV2 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/marketing/make-offer/v2',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postMakeofferV2 = postMakeofferV2;
/**
 * Check if Customer matches TargetingRules in provided TargetingRuleset
 * @param data The data for the request.
 * @param data.rulesetId The (item)ID of the targeting ruleset in Sitecore
 * @param data.customerId Optional for: IdentificationService (customers)
 * @param data.supplyAddressKey Optional for: IdentificationService (non-customers, customers)
 * @returns MatchTargetingRulesetResponseBodyV1 OK
 * @throws ApiError
 */
const getMatchtargetingrulesetV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/marketing/match-targeting-ruleset/v1',
        query: {
            ruleset_id: data.rulesetId,
            customer_id: data.customerId,
            supply_address_key: data.supplyAddressKey
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getMatchtargetingrulesetV1 = getMatchtargetingrulesetV1;
